import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品仕様取込アップロードクラス
 *
 * @export RegistEBaseDataService
 * @class RegistEBaseDataService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class RegistEBaseDataService extends PlessJsonUploadServiceSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private overlapChkFlag: boolean;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistEBaseDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OverlapChkFlag: this.overlapChkFlag
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistEBaseDataService
   */
  execute(model: KYMW1100Model, file: File, overlapChkFlag: boolean, successFunc: Function = null): void {
    this.model = model;
    this.overlapChkFlag = overlapChkFlag;
    this.successFunc = successFunc;
    this.sendFile('registEBaseData', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistEBaseDataService
   */
  success(data: any): void {
    this.model.setEbaseDataKYMW0D00(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
